import styled from 'styled-components'
import type { AnyStyledComponent } from 'styled-components'

import CloseIconSvg from '../../../../assets/icons/gallery/close.svg'
import LeftChevronSvg from '../../../../assets/icons/gallery/left-chevron.svg'
import RightChevronSvg from '../../../../assets/icons/gallery/right-chevron.svg'
import LeftNavigatorSvg from '../../../../assets/icons/gallery/left-navigator.svg'
import RightNavigatorSvg from '../../../../assets/icons/gallery/right-navigator.svg'

export const CloseIcon = styled(CloseIconSvg as AnyStyledComponent)`
    width: 100%;
    height: 100%;
`

export const LeftChevron = styled(LeftChevronSvg as AnyStyledComponent)`
    width: 100%;
    height: 100%;
`

export const RightChevron = styled(RightChevronSvg as AnyStyledComponent)`
    width: 100%;
    height: 100%;
`

export const LeftNavigator = styled(LeftNavigatorSvg as AnyStyledComponent)`
    width: 100%;
    height: 100%;
`

export const RightNavigator = styled(RightNavigatorSvg as AnyStyledComponent)`
    width: 100%;
    height: 100%;
`
